import { ScrollingModule } from '@angular/cdk/scrolling';
import { Location } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  FwAvatarModule,
  FwButtonModule,
  FwButtonToggleModule,
  FwCardModule,
  FwContainedInputModule,
  FwIconButtonModule,
  FwIconModule,
  FwLayoutsModule,
  FwMenuModule,
  FwSectionHeadingModule,
  FwSelectMenuModule,
  FwSwitchModule,
  FwTextInputModule,
} from '@flywheel-io/vision';
import { Subscription } from 'rxjs';
import { distinctUntilKeyChanged } from 'rxjs/operators';

import { AdminModule } from 'app/src/admin/admin.module';
import { DirectivesModule } from 'app/src/common/directives.module';
import { ContainerModule } from 'app/src/containers/container.module';
import { FileModule } from 'app/src/files/file.module';
import { MaterialModule } from 'app/src/material.module';
import { SessionModule } from 'app/src/sessions/session.module';
import { PipesModule } from 'app/src/shared/pipes.module';
import { SharedModule } from 'app/src/shared/shared.module';

import { replayLocation } from '../../shared/observable.utils';
import { ProjectCatalogComponent } from '../project-catalog/project-catalog.component';
import { ProjectListComponent } from '../project-list/project-list.component';

@Component({
  host: {
    class: 'page-content',
    'test-id': 'project-index',
  },
  selector: 'project-index',
  styles: [
    `
      .tab-content {
        height: 100%;
      }

      :host::ng-deep.mat-mdc-tab-body-wrapper {
        flex-grow: 1;
      }

      :host {
        width: 100%;
      }
    `,
  ],
  template: `
    <header class="content-header">
      <h4 class="vision-h4">Projects</h4>
    </header>

    <mat-tab-group
      [(selectedIndex)]="selectedTabIndex"
      (selectedTabChange)="tabChanged()"
      mat-stretch-tabs="false"
      class="content-body tabs-white"
    >
      <mat-tab [label]="'projectIndex.tabs.list' | translate">
        <ng-template matTabContent>
          <project-list class="tab-content"></project-list>
        </ng-template>
      </mat-tab>
      <mat-tab [label]="'projectIndex.tabs.catalog' | translate">
        <ng-template matTabContent>
          <project-catalog class="tab-content"></project-catalog>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  `,
  imports: [
    AdminModule,
    ContainerModule,
    DirectivesModule,
    FileModule,
    FormsModule,
    FwAvatarModule,
    FwButtonModule,
    FwButtonToggleModule,
    FwCardModule,
    FwContainedInputModule,
    FwIconButtonModule,
    FwIconModule,
    FwLayoutsModule,
    FwMenuModule,
    FwSectionHeadingModule,
    FwSelectMenuModule,
    FwSwitchModule,
    FwTextInputModule,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    ScrollingModule,
    SessionModule,
    SharedModule,
    RouterModule,
    ProjectListComponent,
    ProjectCatalogComponent,
  ],
})
export class ProjectIndexComponent implements OnDestroy {
  selectedTabIndex = 0;

  private subscriptions = {
    location: Subscription.EMPTY,
  };

  constructor() {
    const location = inject(Location);

    this.subscriptions.location = replayLocation(location)
      .pipe(distinctUntilKeyChanged('url'))
      .subscribe(() => {
        this.captureRouteState();
      });
  }

  ngOnDestroy(): void {
    for (const subscription of Object.values(this.subscriptions)) {
      subscription.unsubscribe();
    }
  }

  private captureRouteState(): void {
    // this.selectedTabIndex = this.router.current.name === 'index.projectCatalog' ? 1 : 0;
  }

  tabChanged(): void {
    /*
    const selectedName = this.selectedTabIndex === 1 ? 'index.projectCatalog' : 'index.projects';
    if (this.router.current.name !== selectedName) {
      this.router.go(selectedName, undefined, { notify: false });
    }
    */
  }
}
